import { langId } from "../languages"
const linkConfig = [
  {
    title: langId.HOME,
    baseSlug: "",
  },
  {
    title: langId.CEOS_VIEWS,
    baseSlug: "link-ceo-george-hongchoy-views-the-quayside-lit-up",
  },
  {
    title: langId.CORPORATE_NEWS,
    baseSlug: "link-turns-15",
  },
  {
    title: langId.FEATURE_STORIES,
    baseSlug: "link-feature-stories",
  },
  {
    title: langId.LINK_TOGETHER_INITIATIVES,
    baseSlug: "link-together-initiatives-lets-shine-on-stage",
  },
  {
    title: langId.THE_LINK_MOMENTS,
    baseSlug: "link-marketing-updates-quality-japanese-f-and-b-brands",
  },
]

export default linkConfig
